/* QUEUE N2c fix 3 (2026-10-06): THE WEB NEVER RE-READ WHEN THE COACH CAME BACK.
 *
 * The N2 walk: a client finishing a workout reached the coach's open web tab only on a full reload — the roster's four reads
 * and the client page ran on mount and after the coach's OWN writes, never on return. The phone's twin is fix 2's scenePhase
 * reload (`a1f1ddec`). This is a counter that moves when the tab becomes VISIBLE again; a reader puts it in its effect's deps.
 *
 * ⚠️ THE GAP IS A FLOOR, not a timer: nothing polls. A tab flicked away and back inside `minGapMs` re-reads nothing — the reads
 * are four queries, and a coach alt-tabbing to copy a link should not pay them each time.
 * ⚠️ The refetch is QUIET by the readers' own design (neither sets `loading` before its query), so the page never blanks.
 */
import { useEffect, useRef, useState } from "react";

/** Whether a return at `nowMs` re-reads, given the last read at `lastMs`. Pure, for the test. */
export function returnRereads(nowMs: number, lastMs: number, minGapMs: number): boolean {
  return nowMs - lastMs >= minGapMs;
}

export function useReturnTick(minGapMs = 30_000): number {
  const [tick, setTick] = useState(0);
  const last = useRef(Date.now());
  useEffect(() => {
    function onVisibility() {
      if (document.visibilityState !== "visible") return;
      const now = Date.now();
      if (!returnRereads(now, last.current, minGapMs)) return;
      last.current = now;
      setTick((t) => t + 1);
    }
    document.addEventListener("visibilitychange", onVisibility);
    return () => document.removeEventListener("visibilitychange", onVisibility);
  }, [minGapMs]);
  return tick;
}
